const userAgentToDistribPlatformMatrix = {
    itunes: 'apple',
    Android: 'google',
    googleplay: 'google',
    amazonmobile: 'amazon',
    facebook: 'facebook',
    samsung: 'samsung',
    huawei: 'huawei',
}

export const detectPlatform = (defaultPlatform = 'stillpay'): string => {
    const nativePlatform = navigator.userAgent.match(
        /(itunes)|(googleplay)|(Android)|(amazonmobile)|(facebook)|(samsung)|(huawei)/g
    )
    if (!nativePlatform) return defaultPlatform
    const activePlatform = nativePlatform[0]

    return Object.prototype.hasOwnProperty.call(userAgentToDistribPlatformMatrix, activePlatform)
        ? userAgentToDistribPlatformMatrix[activePlatform as keyof typeof userAgentToDistribPlatformMatrix]
        : defaultPlatform
}

const distribPlatformToProviderMatrix = {
    apple: 'itunes',
    google: 'googleplay',
    amazon: 'amazonmobile',
    facebook: 'facebook',
    samsung: 'samsung',
    huawei: 'huawei',
}

export const createProductIdsForPlatform = (platform: keyof typeof distribPlatformToProviderMatrix, id: string) => {
    if (!Object.prototype.hasOwnProperty.call(distribPlatformToProviderMatrix, platform))
        throw new Error(`Platform ${platform} is not supported`)

    const res = Object.create(null)
    res[distribPlatformToProviderMatrix[platform]] = id
    return res
}
